/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageBtnComponent } from './manage-btn.component';

@NgModule({
  declarations: [ManageBtnComponent],
  imports: [CommonModule],
  exports: [ManageBtnComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ManageBtnModule {}
